import React,{useState,useEffect} from 'react';
import { connect } from 'react-redux';

import { CategoryCard, Card, TemplatePreviewBox, Modal, Loading } from '../../components';

import {
  validateTemplate,
  saveTemplate,
} from "../../services/templates";

import templateModel from "../../models/template";

import ModalCustomCategory from './modal-custom-category';


import {
  // saveTemplateCatRelevance,
  // saveTemplateCatOrder,
  // saveTemplateTopicRelevance,
  // saveTemplateTopicOrder,
  // addTemplateTopic,
  setTemplateEditing,
  addTemplateCategory,
  startGetDefaultTemplate,
  startGetUserTemplates,
  setTemplateErrorsIds,
  saveTemplateTitle,
  startGetOfficialTopics
} from '../../actions';


import './templates.css';


const Templates = ({
  template, // current template being edited
  defaultTemplates,
  userTemplates,
  userTemplateStatus,
  getDefaultTemplates,
  getUserTemplates,
  setEditing,
  addCategory,
  setErrorIds,
  errorIds,
  saveTemplateTitle,
  topics,
  startGetOfficialTopics,
  history
}) => {

  const [addingCategory,setAddingCategory]=useState('');
  const [isOpenModalAlert,setIsOpenModalAlert]=useState(false);
  const [isOpenModalCategory,setIsOpenModalCategory]=useState(false);
  const [isOpenModalFirstTemplate,setIsOpenModalFirstTemplate]=useState(false);
  const [isSaving,setIsSaving]=useState(''); // saving template status ('' || 'loading')
  const [noEditing,setNoEditing]=useState(true); // saving template status ('' || 'loading')

  useEffect(()=>{
    if(!defaultTemplates || !defaultTemplates.length) {
      getDefaultTemplates();
    }

  },[defaultTemplates]);

  useEffect(()=>{
    if(!userTemplates || !userTemplates.length) {
      getUserTemplates();
    }
    startGetOfficialTopics(true);
    setNoEditing(!templateName);
  },[])


  const onSetCustom=()=>{
    const newCustom=templateModel();
    setEditing(newCustom);
    setNoEditing(false);
  }
  
  const onSetEditing=(template)=>{
    setNoEditing(false);
    setEditing(template);
  }
  
  const onChange=(fnc)=>{
    return ({target:{value}})=>{
      fnc(value);
    }
  }

  // template
  const { categories } = template;
  const templateName=template.template;

  // const noEditing = !templateName;

  console.log('current editing',template);
  // console.log('user templates',userTemplates);

  const onSaveTemplate = async ()=>{
    const errorsIds=validateTemplate(template);
    if(errorsIds.length) {
      console.log('### Errors: ',errorsIds);
      if(template.categories.length)
        setIsOpenModalAlert(true);
    } else {
      console.log('###################### TEMPLATE TO SAVE:');
      console.log(template);
      setIsSaving('loading');
      const savedTemplate = await saveTemplate(template);
      setEditing(savedTemplate);
      setIsSaving('');
      if(!userTemplates.length) setIsOpenModalFirstTemplate(true);
      getUserTemplates();
    }
    setErrorIds(errorsIds);
  }

  const onAddCategory=({target:{value}})=>{
    setAddingCategory('');
    if(value === 'CUSTOM') {
      setIsOpenModalCategory(true);
      return false;
    }
    addCategory(value);
    setTimeout(()=>{
      const height=document.scrollingElement.getClientRects()[0].height;
      document.scrollingElement.scrollTop=height;
    },100);
  }



  // categories / topics (only non-existant categories; categories not added yet)
  const allCategories = topics.reduce((accum, curr) => {
    const { category } = curr;
    if(categories.some(elem=>elem.category===category)) {
      return accum;
    }
    if (category) {
      return [...accum, {value:category,label:category}]
    }
    return accum;
  }, []);

  allCategories.unshift({value:'CUSTOM',label:'CUSTOM'});
  allCategories.unshift({value:'',label:'--Select--'});
  const categoriesSelect = (<select onChange={onAddCategory} disabled={noEditing} value={addingCategory}>
    {allCategories.map(({value,label}, index) => <option key={'cats_sel_' + index} value={value}>{label}</option>)}
  </select>)



  const closeModalAlert=()=>{
    setIsOpenModalAlert(false)
  }

  const closeModalFirstTemplate=()=>{
    setIsOpenModalFirstTemplate(false);
    history.push('/dashboard');
  }

  // Alert Modal
  const alertModal=(
    <Modal isOpen={isOpenModalAlert} onClose={closeModalAlert} className="modal-content-default template-alert-modal">
      <div className="font-color2">
        <h3 className="font-color-error1">Errors were found!</h3>
        <p>Please check all the categories/topics highlighted in <span className="font-color-error1">red</span>.</p>
        <p className="template-alert-modal-error-hint">
          Check all categories's and topic's relevance fields. It *MUST* be between 1 and 5.
        </p>
        <div className="modal-controls">
          <button onClick={closeModalAlert} className="btn btn-default1" type="button">Ok</button>
        </div>
      </div>
    </Modal>
  )

  // Alert Modal
  const alertModalFirstTemplate=(
    <Modal isOpen={isOpenModalFirstTemplate} onClose={closeModalFirstTemplate} className="modal-content-default">
      <div className="font-color2">
        <h3 className="notice1">Now that you have your master calculator, you can start calculating your market fit in different countries.</h3>
        <div className="modal-controls">
          <button onClick={closeModalFirstTemplate} className="btn btn-default1" type="button">Calculate country fit</button>
        </div>
      </div>
    </Modal>
  )



  // default templates
  // console.log('defaultmteplate',defaultTemplates);
  const defaultTemplatesHtml = <TemplatePreviewBox onClick={onSetEditing} templates={defaultTemplates} title="Default Templates" />

  // user templates
  const userTemplatesHtml = <TemplatePreviewBox onClick={onSetEditing} status={userTemplateStatus} type={2} templates={userTemplates} title="My Templates" />


  let temlateTitleField=false;
  if(!noEditing) {
    const errorTitle = errorIds.includes('TITLE') ? <small className="error-msg">Empty title not allowed!</small> : false;
    const errorNoCat = errorIds.includes('NO-CATEGORY') ? <small className="error-msg">You must create at least one category with at least one topic!</small> : false;
    temlateTitleField=(
      <div className="editing-template-title">
        <h2>Template Title:
          <input className="textfield1" type="text" onChange={onChange(saveTemplateTitle)} value={templateName} />
        </h2>
        {errorTitle}
        {errorNoCat}
      </div>
    )
  }


  const categoriesHtml = categories.map((cat, index) => <CategoryCard index={index} key={'template_cat_' + index} category={cat} />)

  const manageModalCategory=(fnc)=>{
    if(fnc === 'close') {
      return () => {
        setIsOpenModalCategory(false);
      }
    }

    if(fnc === 'save') {
      return (value)=>{
        onAddCategory({target:{value}});
        setIsOpenModalCategory(false);
      }
    }
  }

  return (
    <div className="background-default1 page-content">
      <ModalCustomCategory isOpen={isOpenModalCategory} onCancel={manageModalCategory('close')} onSave={manageModalCategory('save')} />
      <h2 className="page-title">Template / Master Calculator</h2>
      <Card className="template-header font-color2">
        <h1>Create your master calculator</h1>
        <p>
          The master calculator is the basis you will use to compare different countries. The categories and topics you add here will be autmoatically duplicated to each country you decide to analyze during the next steps.
        </p>
        <p>
          If you choose a template, you will see a pre-defined setup with different topics for your comparision. Now, you need to customize it according to the needs and goals and needs of your company.
        </p>
      </Card>
      <div className="template-preview-wrapper">
        <Loading status={[userTemplateStatus,isSaving]} />
        {defaultTemplatesHtml}
        {userTemplatesHtml}
      </div>
      <div className="template-build-tools">
        <h3>Add Category: {categoriesSelect}</h3>
        <button onClick={onSetCustom}  className="btn btn-default-ok btn-xs" type="button">New Custom Template</button>
        <button onClick={onSaveTemplate} disabled={(noEditing || !!isSaving)} className="btn btn-default-ok" type="button">SAVE CURRENT TEMPLATE</button>
      </div>
      <div className="template-display">
        {temlateTitleField}
        {categoriesHtml}
      </div>
      {alertModal}
      {alertModalFirstTemplate}
    </div>
  )
}

const mapState2Props = ({ template, topics }) => ({
  template: template.editingTemplate,
  defaultTemplates: template.defaultTemplates,
  userTemplates: template.userTemplates,
  userTemplateStatus: template.userTemplateStatus,
  topics: topics.topics,
  errorIds: template.errorIds
});


const mapDispatch2Props=(dispatch)=>({
  setEditing: (template) => dispatch(setTemplateEditing(template)),
  getDefaultTemplates:()=>dispatch(startGetDefaultTemplate()),
  getUserTemplates:()=>dispatch(startGetUserTemplates()),
  addCategory: (category) => dispatch(addTemplateCategory(category)),
  setErrorIds: (errorIds)=>dispatch(setTemplateErrorsIds(errorIds)),
  saveTemplateTitle: (title)=>dispatch(saveTemplateTitle(title)),
  startGetOfficialTopics: (checkUpdate)=>dispatch(startGetOfficialTopics(checkUpdate))
})

export default connect(mapState2Props,mapDispatch2Props)(Templates);
